var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 24,
      height: 24,
      overflow: "visible",
      fill: "rgb(3, 3, 3)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H1v13c0 1.1.9 2 2 2h17v-2H3V6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4h-7l-2-2H7c-1.1 0-1.99.9-1.99 2L5 15c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCopy);
export default __webpack_public_path__ + "static/media/folder_copy.a1f2c316bfa3f4da3ee6bc10a80e929e.svg";
export { ForwardRef as ReactComponent };